
export default {
  name: 'CategoriesGrid'
}
